module.exports = __webpack_public_path__ + "static/media/ex1.fe8f79ce.mp3";